import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import { useGlobalAuthStore } from '@Stores/global/auth';
import history from 'utils/history';

import Form from '../components/Form';
import { OrganizationProvider, useOrganizationStore } from '../store';

const OrganizationForm = () => {
  const { id } = useParams()
  const { auth: { getCurrentSession } } = useGlobalAuthStore()
  const { collection: { item, useLoad, useSubmit, reset } } = useOrganizationStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleSidebarClose = useCallback(() => {
    history.push("/admin/organizations");
    reset()
  }, [reset])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      await getCurrentSession()
      handleSidebarClose()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Organization ${message}.`)
    } catch (error) {
      handleError('Error', 'Organization was not saved.')
    }
  }, [handleSubmit, handleSidebarClose, getCurrentSession, handleSuccess, handleError]);

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleSidebarClose() }}
      title={item.id ? 'Edit Organization' : 'Add Organization'}
    >
      <Helmet title="Organization" />
      <Form data={item} handleSubmit={handleSubmitAndClose} />
    </DefaultSheet>
  </>
}

OrganizationForm.propTypes = {
  match: PropTypes.object,
};

export default function OrganizationFormLayout() {
  return <OrganizationProvider>
    <OrganizationForm />
  </OrganizationProvider>
}
